import { render, staticRenderFns } from "./ComponentPickerDialog.vue?vue&type=template&id=1b52a560"
import script from "./ComponentPickerDialog.vue?vue&type=script&lang=js"
export * from "./ComponentPickerDialog.vue?vue&type=script&lang=js"
import style0 from "./ComponentPickerDialog.vue?vue&type=style&index=0&id=1b52a560&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports